import { Component } from '@angular/core';
import {HeaderComponent} from "../../header/header.component";
import {FooterComponent} from "../../footer/footer.component";
import {Router} from "@angular/router";

@Component({
  selector: 'vex-refund-policy',
  standalone: true,
  imports: [
    HeaderComponent,
    FooterComponent
  ],
  templateUrl: './refund-policy.component.html',
  styleUrl: './refund-policy.component.scss'
})
export class RefundPolicyComponent {
  constructor(private router: Router) {
  }
  goTo(url) {
    this.router.navigateByUrl(url);
  }
}
